import { createTypes, createAction } from 'lib/action'
const LOAD_SHIPMENT_CONTRACT = createTypes('loadshipmentcontract','load')
const CREATE_SHIPMENT_CONTRACT = createTypes(
  'createshipmentcontract',
  'create',
)
const UPDATE_SHIPMENT_CONTRACT = createTypes(
  'updateshipmentcontract',
  'update',
)
const LOAD_SHIPMENT_CONTRACT_DETAIL = createTypes(
  'loadshipmentcontractdetail',
  'load',
)

const REMOVE_LISTS = `REMOVE_LISTS`

function removeLists() {
    return {
      type: REMOVE_LISTS,
    }
}

const loadShipmentContract = {
    request: (data, loading) =>
      createAction(LOAD_SHIPMENT_CONTRACT.REQUEST, { data, loading }),
    success: (lists, page, pageSize) =>
      createAction(LOAD_SHIPMENT_CONTRACT.SUCCESS, { lists, page, pageSize }),
    failure: () => createAction(LOAD_SHIPMENT_CONTRACT.FAITLURE),
}

const createShipmentContract = {
  request: (data, cb) =>
    createAction(CREATE_SHIPMENT_CONTRACT.REQUEST, { data, cb }),
  success: res => createAction(CREATE_SHIPMENT_CONTRACT.SUCCESS, { res }),
  failure: () => createAction(CREATE_SHIPMENT_CONTRACT.FAITLURE),
}

const updateShipmentContract = {
  request: (data, cb) =>
    createAction(UPDATE_SHIPMENT_CONTRACT.REQUEST, { data, cb }),
  success: res => createAction(UPDATE_SHIPMENT_CONTRACT.SUCCESS, { res }),
  failure: () => createAction(UPDATE_SHIPMENT_CONTRACT.FAITLURE),
}

const loadShipmentContractDetail = {
  request: (data, loading) =>
    createAction(LOAD_SHIPMENT_CONTRACT_DETAIL.REQUEST, { data, loading }),
  success: listsEdit =>
    createAction(LOAD_SHIPMENT_CONTRACT_DETAIL.SUCCESS, { listsEdit }),
  failure: () => createAction(LOAD_SHIPMENT_CONTRACT_DETAIL.FAITLURE),
}

export {
    LOAD_SHIPMENT_CONTRACT,
    loadShipmentContract,
    LOAD_SHIPMENT_CONTRACT_DETAIL,
    loadShipmentContractDetail,
    CREATE_SHIPMENT_CONTRACT,
    createShipmentContract,
    UPDATE_SHIPMENT_CONTRACT,
    updateShipmentContract,
    REMOVE_LISTS,
    removeLists,
}
  